import { D2CSiteContentSlot } from '@orcar/common';
import { useSiteImageList } from '@orcar/common-d2c';
import {
  HOME_BANNERS_FALLBACK,
  HOME_HERO_FALLBACK,
  HOME_POPUP_FALLBACK,
} from '@/constants/site-content';

export const useHomeHero = () =>
  useSiteImageList(D2CSiteContentSlot.HOME_HERO, HOME_HERO_FALLBACK);

export const useHomeBanners = () =>
  useSiteImageList(D2CSiteContentSlot.HOME_BANNERS, HOME_BANNERS_FALLBACK);

export const useHomePopup = () =>
  useSiteImageList(D2CSiteContentSlot.HOME_POPUP, HOME_POPUP_FALLBACK);
